import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id FA105BDA-FD31-4A8E-86AD-1C02073B05B7
 * name bench-back
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bench-back.svg
 * tags
 */
export const BenchBackIcon = createSvgIcon(<><path d="M4 5C3.45 5 3 5.45 3 6V10C3 10.55 3.45 11 4 11H5V13H1V15H3V19H5V15H19V19H21V15H23V13H19V11H20C20.55 11 21 10.55 21 10V6C21 5.45 20.55 5 20 5H4M17 11V13H7V11H17Z" /></>, 'BenchBackIcon');
export default BenchBackIcon